/*
===============================================================================
VLETTE QUICK ADD JS
Shared responsive quick add for V·lette summary and colour product cards.

- Summary cards: choose colour, then size.
- Colour cards: colour is fixed by the card; choose size only.
- Mobile: bottom sheet. Desktop: centred dialog (controlled by CSS).
===============================================================================
*/

(function () {
  'use strict';

  if (window.__vletteCollectionAtcInit) return;
  window.__vletteCollectionAtcInit = true;

  var mobileQuery = window.matchMedia('(max-width: 768px)');
  var activeSheet = null;
  var activeVariantId = null;
  var activeVariant = null;
  var activeProductData = null;
  var activeColour = null;
  var activeTrigger = null;
  var lastFocusedElement = null;
  var closeTimer = null;
  var successCloseTimer = null;

  function closest(element, selector) {
    return element && element.closest ? element.closest(selector) : null;
  }

  function getSheetFromTrigger(trigger) {
    if (!trigger) return document.querySelector('[data-vlette-collection-atc-sheet]');

    var sheetId = trigger.getAttribute('data-vlette-collection-atc-sheet-id') || trigger.getAttribute('aria-controls');

    if (sheetId) {
      var controlledSheet = document.getElementById(sheetId);
      if (controlledSheet && controlledSheet.matches('[data-vlette-collection-atc-sheet]')) {
        return controlledSheet;
      }
    }

    var localSection = closest(trigger, '[data-vlette-summary-section], [data-vlette-summary-stack], [data-vlette-style-catalogue], section');
    if (localSection) {
      var localParent = localSection.parentElement;
      var localSheet = localParent ? localParent.querySelector('[data-vlette-collection-atc-sheet]') : null;
      if (localSheet) return localSheet;
    }

    return document.querySelector('[data-vlette-collection-atc-sheet]');
  }

  function getPanel(sheet) {
    return sheet ? sheet.querySelector('.vlette-collection-atc-sheet__panel') : null;
  }

  function getProductLine(sheet) {
    return sheet ? sheet.querySelector('[data-vlette-collection-atc-product-line]') : null;
  }

  function getDetailsLink(sheet) {
    return sheet ? sheet.querySelector('[data-vlette-collection-atc-details]') : null;
  }

  function getColourGroup(sheet) {
    return sheet ? sheet.querySelector('[data-vlette-collection-atc-colour-group]') : null;
  }

  function getColours(sheet) {
    return sheet ? sheet.querySelector('[data-vlette-collection-atc-colours]') : null;
  }

  function getSizeGroup(sheet) {
    return sheet ? sheet.querySelector('[data-vlette-collection-atc-size-group]') : null;
  }

  function getSizes(sheet) {
    return sheet ? sheet.querySelector('[data-vlette-collection-atc-sizes]') : null;
  }

  function getSubmit(sheet) {
    return sheet ? sheet.querySelector('[data-vlette-collection-atc-submit]') : null;
  }

  function getStatus(sheet) {
    return sheet ? sheet.querySelector('[data-vlette-collection-atc-status]') : null;
  }

  function getRouteRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function getVariantQuantityFromCart(cart, variantId) {
    if (!cart || !cart.items || !cart.items.length || !variantId) return 0;

    var quantity = 0;

    for (var i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].id) === String(variantId)) {
        quantity += Number(cart.items[i].quantity || 0);
      }
    }

    return quantity;
  }

  function fetchCartJson(path, options) {
    return fetch(getRouteRoot() + path, options || {})
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok) {
            var message = json && (json.description || json.message) ? (json.description || json.message) : 'Could not update cart.';
            throw new Error(message);
          }

          return json;
        });
      });
  }

  function closeUpcartIfItOpens() {
    if (typeof window.upcartCloseCart === 'function') {
      try {
        window.upcartCloseCart();
      } catch (error) {
        // Non-critical: the V·lette success state should remain visible.
      }
    }
  }

  function keepUpcartClosedBriefly() {
    closeUpcartIfItOpens();

    window.setTimeout(closeUpcartIfItOpens, 80);
    window.setTimeout(closeUpcartIfItOpens, 220);
    window.setTimeout(closeUpcartIfItOpens, 520);
    window.setTimeout(closeUpcartIfItOpens, 900);
  }

  function updateVisibleCartCounts(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;

    var itemCount = Number(cart.item_count || 0);
    var countText = String(itemCount);
    var selectors = [
      '[data-cart-count]',
      '[data-header-cart-count]',
      '.cart-count',
      '.cart-count-bubble span[aria-hidden="true"]',
      '.cart-count-bubble > span:first-child',
      '.site-header__cart-count',
      '.cart-link__bubble-num',
      '.cart-link__bubble span',
      '.js-cart-count'
    ];

    selectors.forEach(function (selector) {
      var elements = document.querySelectorAll(selector);

      for (var i = 0; i < elements.length; i++) {
        elements[i].textContent = countText;
        elements[i].setAttribute('data-cart-count', countText);
      }
    });

    var bubbleSelectors = [
      '.cart-count-bubble',
      '.cart-link__bubble',
      '[data-cart-count-bubble]'
    ];

    bubbleSelectors.forEach(function (selector) {
      var bubbles = document.querySelectorAll(selector);

      for (var i = 0; i < bubbles.length; i++) {
        bubbles[i].classList.toggle('hide', itemCount < 1);
        bubbles[i].classList.toggle('hidden', itemCount < 1);
        bubbles[i].setAttribute('aria-hidden', itemCount < 1 ? 'true' : 'false');
      }
    });
  }

  function syncUpcartQuietly(cart) {
    keepUpcartClosedBriefly();
    updateVisibleCartCounts(cart);

    try {
      if (cart && typeof window.upcartPreloadedCart !== 'undefined') {
        window.upcartPreloadedCart = JSON.stringify(cart);
      }
    } catch (error) {
      // Non-critical: Upcart can still refresh itself if its API is available.
    }

    if (typeof window.upcartRefreshCart === 'function') {
      try {
        window.upcartRefreshCart();
      } catch (error) {
        // Keep the V·lette quick-add success state even if Upcart cannot refresh.
      }
    }

    keepUpcartClosedBriefly();
  }

  function haltAtcEvent(event) {
    if (!event) return;

    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
  }

  function parseCardData(card) {
    if (!card) return null;

    var script = card.querySelector('[data-vlette-collection-atc-data]');
    if (!script) return null;

    try {
      var productData = JSON.parse(script.textContent || script.innerHTML || '{}');
      var activeSwatch = card.querySelector('[data-vlette-summary-colour-swatch].is-active, [data-vlette-summary-colour-swatch][aria-pressed="true"]');

      if (activeSwatch && productData && productData.mode === 'summary') {
        productData.selectedColourHandle = activeSwatch.getAttribute('data-vlette-colour-handle') || productData.selectedColourHandle || '';
        productData.selectedColour = activeSwatch.getAttribute('data-vlette-colour-name') || productData.selectedColour || '';
      }

      return productData;
    } catch (error) {
      return null;
    }
  }

  function getProductColours(productData) {
    if (!productData) return [];

    if (Array.isArray(productData.colours) && productData.colours.length) {
      return productData.colours;
    }

    if (Array.isArray(productData.variants)) {
      return [{
        name: productData.colour || '',
        handle: '',
        swatchColor: productData.swatchColor || null,
        swatchImage: productData.swatchImage || null,
        available: productData.variants.some(function (variant) { return !!variant.available; }),
        url: productData.productUrl || '',
        variants: productData.variants
      }];
    }

    return [];
  }

  function findColour(productData, colourHandle) {
    var colours = getProductColours(productData);

    for (var i = 0; i < colours.length; i++) {
      if (String(colours[i].handle || '') === String(colourHandle || '')) {
        return colours[i];
      }
    }

    return null;
  }

  function getInitialColour(productData) {
    var colours = getProductColours(productData);
    if (!colours.length) return null;

    var requestedColour = findColour(productData, productData.selectedColourHandle);

    if (requestedColour) {
      return requestedColour;
    }

    for (var i = 0; i < colours.length; i++) {
      if (colours[i].available) return colours[i];
    }

    return requestedColour || colours[0];
  }

  function getUniqueSizeVariants(colour) {
    var variants = colour && Array.isArray(colour.variants) ? colour.variants : [];
    var seen = Object.create(null);
    var unique = [];

    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      var label = variant.size || variant.title || 'One size';
      var key = String(label).toLowerCase();

      if (typeof seen[key] === 'undefined') {
        seen[key] = unique.length;
        unique.push(variant);
      } else if (!unique[seen[key]].available && variant.available) {
        unique[seen[key]] = variant;
      }
    }

    return unique;
  }

  function setStatus(message, isError) {
    var status = getStatus(activeSheet);
    if (!status) return;

    status.textContent = message || '';
    status.style.color = isError ? '#8A3B32' : 'rgba(34, 48, 48, 0.62)';
  }

  function resetSubmit(sheet) {
    var submit = getSubmit(sheet);
    if (!submit) return;

    submit.classList.remove('is-success');
    submit.textContent = activeVariantId ? 'Add to cart' : 'Select your size';
    submit.disabled = !activeVariantId;
    submit.removeAttribute('aria-busy');
  }

  function getSiteHighlightColour() {
    return window.getComputedStyle(document.documentElement)
      .getPropertyValue('--vlette-site-highlight-colour')
      .trim();
  }

  function getSwatchRingColour(colour) {
    var handle = colour && colour.handle ? String(colour.handle).toLowerCase() : '';

    if (handle === 'black') return '#2A3030';
    if (handle === 'white' || handle === 'ivory' || handle === 'cream' || handle === 'pearl') return '#D8CEC4';
    if (handle === 'sand') return '#CDB9A8';
    if (handle === 'red' || handle === 'ruby' || handle === 'scarlet') return '#A91F2B';
    if (handle === 'ballet-pink' || handle === 'blush' || handle === 'pink') return '#D9A3AD';
    if (handle === 'lilac' || handle === 'lavender') return '#BFC2E7';

    return colour && colour.swatchColor ? colour.swatchColor : getSiteHighlightColour();
  }

  function setSwatchAppearance(swatch, colour) {
    if (!swatch || !colour) return;

    if (colour.swatchColor) {
      swatch.style.setProperty('--vlette-atc-swatch-color', colour.swatchColor);
    } else {
      swatch.style.removeProperty('--vlette-atc-swatch-color');
    }

    swatch.style.setProperty('--vlette-atc-swatch-ring-color', getSwatchRingColour(colour));

    if (colour.swatchImage) {
      swatch.style.setProperty('--vlette-atc-swatch-image', 'url("' + String(colour.swatchImage).replace(/"/g, '\"') + '")');
    } else {
      swatch.style.setProperty('--vlette-atc-swatch-image', 'none');
    }
  }

  function renderProductLine(productData, colour) {
    var productLine = getProductLine(activeSheet);
    var detailsLink = getDetailsLink(activeSheet);

    if (detailsLink) {
      var detailsUrl = colour && colour.url ? colour.url : (productData && productData.productUrl ? productData.productUrl : '');

      if (detailsUrl) {
        detailsLink.href = detailsUrl;
        detailsLink.hidden = false;
        detailsLink.setAttribute('aria-hidden', 'false');
      } else {
        detailsLink.href = '#';
        detailsLink.hidden = true;
        detailsLink.setAttribute('aria-hidden', 'true');
      }
    }

    if (!productLine) return;

    productLine.innerHTML = '';
    if (!productData) return;

    var productTitle = document.createElement('div');
    productTitle.className = 'vlette-collection-atc-sheet__product-title';
    productTitle.textContent = productData.productTitle || productData.shortTitle || '';
    productLine.appendChild(productTitle);

    if (colour && colour.name) {
      var colourRow = document.createElement('div');
      colourRow.className = 'vlette-collection-atc-sheet__colour-row';

      var swatch = document.createElement('span');
      swatch.className = 'vlette-collection-atc-sheet__swatch';
      swatch.setAttribute('aria-hidden', 'true');
      setSwatchAppearance(swatch, colour);
      colourRow.appendChild(swatch);

      var colourName = document.createElement('span');
      colourName.className = 'vlette-collection-atc-sheet__colour-name';
      colourName.textContent = colour.name;
      colourRow.appendChild(colourName);

      productLine.appendChild(colourRow);
    }
  }

  function renderColourChoices(productData, selectedColour) {
    var colourGroup = getColourGroup(activeSheet);
    var colourWrap = getColours(activeSheet);
    if (!colourGroup || !colourWrap) return;

    var colours = getProductColours(productData);
    var namedColours = colours.filter(function (colour) { return !!colour.name; });
    var shouldShow = !productData.lockedColour && namedColours.length > 1;

    colourGroup.hidden = !shouldShow;
    colourGroup.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    colourWrap.innerHTML = '';

    if (!shouldShow) return;

    for (var i = 0; i < namedColours.length; i++) {
      var colour = namedColours[i];
      var isSelected = selectedColour && String(selectedColour.handle || '') === String(colour.handle || '');
      var button = document.createElement('button');

      button.type = 'button';
      button.className = 'vlette-collection-atc-colour' + (isSelected ? ' is-selected' : '');
      button.setAttribute('data-vlette-collection-atc-colour', '');
      button.setAttribute('data-colour-handle', colour.handle || '');
      button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      button.setAttribute('aria-label', (colour.available ? 'Select ' : 'Sold out: ') + colour.name);

      if (!colour.available) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('title', 'Sold out');
      }

      var swatch = document.createElement('span');
      swatch.className = 'vlette-collection-atc-colour__swatch';
      swatch.setAttribute('aria-hidden', 'true');
      setSwatchAppearance(swatch, colour);
      button.appendChild(swatch);

      var label = document.createElement('span');
      label.className = 'vlette-collection-atc-colour__label';
      label.textContent = colour.name;
      button.appendChild(label);

      colourWrap.appendChild(button);
    }
  }

  function setSelectedVariant(button) {
    var sizeWrap = getSizes(activeSheet);
    var submit = getSubmit(activeSheet);

    if (!button || !sizeWrap || button.disabled) return;

    var buttons = sizeWrap.querySelectorAll('[data-vlette-collection-atc-size]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].classList.remove('is-selected');
      buttons[i].setAttribute('aria-pressed', 'false');
    }

    button.classList.add('is-selected');
    button.setAttribute('aria-pressed', 'true');

    activeVariantId = button.getAttribute('data-variant-id');
    activeVariant = null;

    var variants = getUniqueSizeVariants(activeColour);
    for (var j = 0; j < variants.length; j++) {
      if (String(variants[j].id) === String(activeVariantId)) {
        activeVariant = variants[j];
        break;
      }
    }

    window.clearTimeout(successCloseTimer);

    if (submit) {
      submit.classList.remove('is-success');
      submit.textContent = activeVariantId ? 'Add to cart' : 'Select your size';
      submit.disabled = !activeVariantId;
      submit.removeAttribute('aria-busy');
    }

    setStatus('', false);
  }

  function renderSizes(colour) {
    var sizeGroup = getSizeGroup(activeSheet);
    var sizeWrap = getSizes(activeSheet);
    var submit = getSubmit(activeSheet);

    activeVariantId = null;
    activeVariant = null;
    activeColour = colour || null;

    if (!sizeWrap) return;

    sizeWrap.innerHTML = '';
    if (sizeGroup) sizeGroup.hidden = false;

    var variants = getUniqueSizeVariants(colour);
    var availableCount = 0;

    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      var button = document.createElement('button');

      button.type = 'button';
      button.className = 'vlette-collection-atc-size';
      button.setAttribute('data-vlette-collection-atc-size', '');
      button.setAttribute('data-variant-id', variant.id);
      button.setAttribute('aria-pressed', 'false');
      button.textContent = variant.size || variant.title || 'One size';

      if (!variant.available) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('title', 'Sold out');
      } else {
        availableCount += 1;
      }

      sizeWrap.appendChild(button);
    }

    if (submit) {
      submit.classList.remove('is-success');
      submit.textContent = availableCount ? 'Select your size' : 'Sold out';
      submit.disabled = true;
      submit.removeAttribute('aria-busy');
    }

    if (!variants.length) {
      setStatus('No size options found for this colour.', true);
    } else if (!availableCount) {
      setStatus('This colour is currently sold out.', true);
    } else {
      setStatus('', false);
    }
  }

  function selectColour(colourHandle) {
    if (!activeProductData) return;

    var nextColour = findColour(activeProductData, colourHandle);
    if (!nextColour || !nextColour.available) return;

    activeProductData.selectedColourHandle = nextColour.handle || '';
    activeProductData.selectedColour = nextColour.name || '';
    activeColour = nextColour;

    renderProductLine(activeProductData, nextColour);
    renderColourChoices(activeProductData, nextColour);
    renderSizes(nextColour);
  }

  function openSheet(productData, trigger) {
    if (!productData || !trigger) return;

    var sheet = getSheetFromTrigger(trigger);
    if (!sheet) return;

    if (activeSheet && activeSheet !== sheet && !activeSheet.hidden) {
      closeSheet(activeSheet, false, true);
    }

    window.clearTimeout(closeTimer);
    window.clearTimeout(successCloseTimer);

    activeSheet = sheet;
    activeProductData = productData;
    activeTrigger = trigger;
    activeTrigger.setAttribute('aria-expanded', 'true');
    lastFocusedElement = document.activeElement;
    activeColour = getInitialColour(productData);

    renderProductLine(productData, activeColour);
    renderColourChoices(productData, activeColour);
    renderSizes(activeColour);

    sheet.hidden = false;
    sheet.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('vlette-collection-atc-is-open');

    window.requestAnimationFrame(function () {
      sheet.classList.add('is-visible');

      var panel = getPanel(sheet);
      if (panel) panel.focus({ preventScroll: true });
    });
  }

  function clearActiveState() {
    activeVariantId = null;
    activeVariant = null;
    activeProductData = null;
    activeColour = null;
  }

  function closeSheet(sheet, restoreFocus, immediate) {
    sheet = sheet || activeSheet;
    if (!sheet || sheet.hidden) return;

    if (restoreFocus !== false) restoreFocus = true;

    window.clearTimeout(successCloseTimer);
    window.clearTimeout(closeTimer);

    sheet.classList.remove('is-visible');
    sheet.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('vlette-collection-atc-is-open');

    var finishClose = function () {
      sheet.hidden = true;
      resetSubmit(sheet);

      var status = getStatus(sheet);
      if (status) status.textContent = '';

      if (activeTrigger) {
        activeTrigger.setAttribute('aria-expanded', 'false');
      }

      if (restoreFocus) {
        if (activeTrigger && document.body.contains(activeTrigger)) {
          activeTrigger.focus({ preventScroll: true });
        } else if (lastFocusedElement && document.body.contains(lastFocusedElement)) {
          lastFocusedElement.focus({ preventScroll: true });
        }
      }

      if (sheet === activeSheet) {
        activeSheet = null;
        activeTrigger = null;
        lastFocusedElement = null;
        clearActiveState();
      }
    };

    if (immediate) {
      finishClose();
    } else {
      closeTimer = window.setTimeout(finishClose, 260);
    }
  }

  function addSelectedVariantToCart() {
    var submit = getSubmit(activeSheet);
    var variantId = activeVariantId ? String(activeVariantId) : '';

    if (!variantId || !submit) return;

    window.clearTimeout(successCloseTimer);
    submit.classList.remove('is-success');
    submit.disabled = true;
    submit.textContent = 'Adding...';
    submit.setAttribute('aria-busy', 'true');
    setStatus('', false);

    fetchCartJson('cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      cache: 'no-store'
    })
      .then(function (cart) {
        var currentQuantity = getVariantQuantityFromCart(cart, variantId);
        var updates = {};

        updates[String(variantId)] = currentQuantity + 1;
        keepUpcartClosedBriefly();

        return fetchCartJson('cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function (cart) {
        syncUpcartQuietly(cart);

        submit.classList.add('is-success');
        submit.textContent = 'Added ✓';
        submit.disabled = true;
        submit.removeAttribute('aria-busy');
        setStatus('Added to cart.', false);

        successCloseTimer = window.setTimeout(function () {
          closeSheet(activeSheet, true, false);
        }, 850);
      })
      .catch(function (error) {
        submit.classList.remove('is-success');
        submit.textContent = activeVariantId ? 'Add to cart' : 'Select your size';
        submit.disabled = !activeVariantId;
        submit.removeAttribute('aria-busy');
        setStatus(error && error.message ? error.message : 'Could not add this item to cart.', true);
      });
  }

  function trapFocus(event) {
    if (!activeSheet || activeSheet.hidden || event.key !== 'Tab') return;

    var panel = getPanel(activeSheet);
    if (!panel) return;

    var focusable = panel.querySelectorAll('a[href]:not([hidden]), button:not([disabled]):not([hidden]), [tabindex]:not([tabindex="-1"]):not([hidden])');
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var trigger = closest(target, '[data-vlette-collection-atc-trigger]');

    if (trigger) {
      haltAtcEvent(event);
      if (trigger.disabled) return;

      var card = closest(trigger, '[data-vlette-card]');
      var productData = parseCardData(card);
      if (!productData) return;

      openSheet(productData, trigger);
      return false;
    }

    var close = closest(target, '[data-vlette-collection-atc-close]');
    if (close) {
      haltAtcEvent(event);
      closeSheet(closest(close, '[data-vlette-collection-atc-sheet]'), true, false);
      return false;
    }

    var colour = closest(target, '[data-vlette-collection-atc-colour]');
    if (colour) {
      haltAtcEvent(event);
      if (!colour.disabled) selectColour(colour.getAttribute('data-colour-handle'));
      return false;
    }

    var size = closest(target, '[data-vlette-collection-atc-size]');
    if (size) {
      haltAtcEvent(event);
      setSelectedVariant(size);
      return false;
    }

    var submit = closest(target, '[data-vlette-collection-atc-submit]');
    if (submit) {
      haltAtcEvent(event);
      addSelectedVariantToCart();
      return false;
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeSheet(activeSheet, true, false);
      return;
    }

    trapFocus(event);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (activeSheet && event.target && event.target.contains(activeSheet)) {
      closeSheet(activeSheet, false, true);
    }
  });

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', function () {
      if (activeSheet && !activeSheet.hidden) {
        window.requestAnimationFrame(function () {
          var panel = getPanel(activeSheet);
          if (panel) panel.focus({ preventScroll: true });
        });
      }
    });
  }
})();
